import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import styles from './Deliveries.module.css';

function BlockDetails(props) {
  const { block } = props;

  return (
    <div className={styles.blockDetails}>
      <div className={styles.blockDetail}>
        <span>Start Time:</span>
        <span>{moment(block.starts_at).format('MM-DD-YYYY hh:mm A')}</span>
      </div>

      <div className={styles.blockDetail}>
        <span>End Time:</span>
        <span>{moment(block.ends_at).format('MM-DD-YYYY hh:mm A')}</span>
      </div>

      <div className={styles.blockDetail}>
        <span>Notes:</span>
        <span>{block.notes}</span>
      </div>
    </div>
  );
}

BlockDetails.propTypes = {
  block: PropTypes.shape({}).isRequired,
};

export default BlockDetails;
